<template>
	<div id="modal_wrapper1">
		<section class="modal_window">
			<div class="title clearfix">
				<span class="title_content color_6 pull-left">{{title}}</span>
				<i class="glyphicon icon_off pull-right cursor" @click="modalOff">x</i>
			</div>
			<div class="modal_main">
				<router-link class="hidden" id="defaultClick" :to="linkSrc"></router-link>
				<router-view></router-view>
			</div>
		</section>
	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		props: [
			'title',
			'linkSrc',
		],
		mounted:function(){
			this.$nextTick(function(){
				this.defaultClick();
				this.scrollbar();
			})
		},
		methods: {
			modalOff() {
				this.$emit("modalOff");
				$("body").css("overflow","auto")
			},
			defaultClick(){
				document.getElementById("defaultClick").click();
			},
			scrollbar(){
//				$('.modal_main').perfectScrollbar(); 
			},
			modalWindow(){
			}
			
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	#modal_wrapper1 {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 990;
		overflow: auto;
		background-color: rgba(0, 0, 0, .15);
	}
	
	.modal_window {
		max-width: 96%;
		width: 700px;
		min-width: 700px;
		min-height: 500px;
		padding: 12px;
		margin: 30px auto;
		border-radius: 5px;
		background-color: #fff;
		-webkit-box-shadow: 3px 3px 4px rgba(0, 0, 0, 0.3);
		-moz-box-shadow: 3px 3px 4px rgba(0, 0, 0, 0.3);
		box-shadow: 3px 3px 4px rgba(0, 0, 0, 0.3);
	}
	
	.title {
		height: 20px;
		line-height: 20px;
		margin-bottom: 15px;
	}
	
	.modal_main {
		position: relative;
		width: 100%;
		height: 445px;
		padding: 0 15px;
		overflow: auto;
	}
</style>


// WEBPACK FOOTER //
// agreement_modal.vue?1b998372